<template>
  <div class="l-invite-box">
    <div class="l-invite-container">
      <div class="l-step-result-icon">
        <i class="el-icon-success" style="font-size:70px;color:#67C23A" />
      </div>
      <div class="l-step-result-text">成功加入企业</div>

      <div class="l-invite-success-qr-box">
        <img src="@/assets/images/zwy_qrcode.jpg">
        <div style="margin-top:10px">扫码二维码，进入掌维易小程序</div>
      </div>

    </div>
  </div>

</template>

<script>
  export default {
    name: "l-user-invite-success"
  }
</script>

<style lang="scss" scoped>
  .l-invite-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    bottom: 0;
    overflow: auto;
  }

  .l-invite-container {
    padding: 20px;
    padding-top: 40px;
    max-width: 760px;
    margin: 0 auto;
    // padding: 20px 20px;
  }

  .l-step-result-icon {
    text-align: center;
  }

  .l-step-result-text {
    margin-top: 20px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
  }

  .l-step-result-close {
    margin-top: 30px;
    text-align: center;
  }

  .l-invite-success-qr-box {
    margin-top: 20px;
    text-align: center;
  }
</style>